import { render, staticRenderFns } from "./WarehouseItemsInOutReport.vue?vue&type=template&id=2af865e6"
import script from "./WarehouseItemsInOutReport.vue?vue&type=script&lang=js"
export * from "./WarehouseItemsInOutReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports